export default __webpack_public_path__ + "static/science-jug-76b18deb385a705fb6f6a88bb78410b0.png";